import { useSupportSubjectsListSlice } from '@restore/SupportSubject/SupportSubject.slice';
import { SupportSubjectListView } from 'src/pages/ClinicalTrial/SupportSubjectList/SupportSubjectList.view';
import { useClinicalTrialSlice } from '@restore/clinicalTrial/clinicalTrial.slice';
import { useSupportSubjectListFilters } from 'src/pages/ClinicalTrial/SupportSubjectList/useSupportSubjectListFilters';
import { useCallback } from 'react';
import { SupportSubjectType } from '@dynamika-shared/types/subjects';
import { generatePath } from 'react-router';
import { routesPath } from '@router/routes';
import { useNavigate } from 'react-router-dom';

export const SupportSubjectList = () => {
  const [clinicalTrial] = useClinicalTrialSlice(state => [
    state.data,
    state.loading,
  ]);

  const { onSearch, onSort, sortBy } = useSupportSubjectListFilters();

  const clinicalTrialId = clinicalTrial?.id;

  const [supportSubjectList, loading] = useSupportSubjectsListSlice(state => [
    state.data,
    state.loading,
  ]);

  const navigate = useNavigate();

  const handleSubjectClick = useCallback(
    (subject: SupportSubjectType) => {
      if (!clinicalTrialId) return;
      onSearch('');
      const uri = generatePath(routesPath.clinicalTrialSubjectDetail, {
        id: clinicalTrialId,
        patientId: subject.patientId,
      });
      navigate(uri, { state: { subject } });
    },
    [navigate, clinicalTrialId]
  );

  if (!clinicalTrialId) {
    return null;
  }

  return (
    <div className='relative flex min-h-full w-full grow flex-col'>
      <SupportSubjectListView
        data={supportSubjectList}
        loading={loading}
        onSearch={onSearch}
        onSubjectClick={handleSubjectClick}
        onSort={onSort}
        sortState={sortBy}
      />
    </div>
  );
};
